
import { Grid, useTheme } from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  CardGrid,
  CardBodyGrid,
  DescriptionTypography,
  ImageBox,
  TitleTypography
} from "./CardModule.styles";
// import type { CardModuleProps } from "./CardMoudle.types";
import {
  CardSignature,
  Icon,
  StatusBox
} from "../../components";
import {
  useAccent,
  useIconStatus,
  useType
} from "../../hooks";
import { formatDate, useNavigate } from "../../services";
import { hasPassedExpiration } from "../../utils/datetime";
import type { Module } from "../../utils/explore";
import { CardCtaModule } from "../CardCtaModule";
import { TruncatedText } from "../TruncatedText";


export function CardModule({
  badge,
  booked: _booked,
  certificate,
  coverPublicURL,
  courseId=undefined,
  disabled,
  duration,
  enrollType,
  id,
  isAutoSubscribeEnable: _isAutoSubscribeEnable,
  isMandatory,
  expirationDate,
  isStandAlone,
  isSurvey,
  isTest,
  learningActivityNumber,
  learningObjectType,
  learningObjectTypology,
  madeAttempts,
  maxAttempts,
  minimumScore,
  percentageOfCompletion,
  prereqOrderNumber: _prereqOrderNumber,
  rootId=undefined,
  shortDescription,
  status,
  title,
  toolNumber,
  canAccessNow,
  isLinkRelative,
  link,
  attributes,
  ...props
}: Module) {
  const { t, i18n } = useTranslation();
  const isExpired = hasPassedExpiration(expirationDate);
  const accentColor = useAccent({ isExpired, isMandatory, status });
  const iconStatus = useIconStatus({ status });
  const messageStatusBox = (isExpired && expirationDate && status !== "C" && isMandatory )
    ? `${ t("expired_on") } ${ formatDate(expirationDate.join("/"), i18n.language) }`
    : undefined;
  const theme = useTheme();
  const typeObjectLearning = useType(learningObjectType, learningObjectTypology);
  const navigate = useNavigate();
  const isTestCompleted = isTest && status === "C";
  const [isHovered, setIsHovered] = useState(false);

  return (
    <CardGrid container { ...props } onMouseEnter={ () => setIsHovered(true) } onMouseLeave={ () => setIsHovered(false) }>
      <Grid
        item
        xs={ false }
        height={ "236px" }
        margin={ "0 0 8px" }
        position={ "relative" }
        width={ "313px" }
        sx={ {
          filter: "drop-shadow(25px 25px 80px rgba(21, 21, 21, 0.4))"
        } }
      >
        { status === "C"  || isMandatory  ?
          <StatusBox
            message={ messageStatusBox }
            accent={ accentColor }
            icon={ iconStatus }
          /> : null
        }
        <ImageBox
          alt="card cover"

          src={ coverPublicURL }
          onClick={ ()=> {
            if(!disabled){
              const isForYou = window.location.href.includes("per-te");

              navigate.navigateToDetail({
                id,
                isForYou,
                learningObjectTypology,
                courseId: courseId,
                rootId: rootId
              });
            }

          } }

          sx={ {
            cursor:disabled ? "not-allowed" : "pointer"
          } }
        />
      </Grid>
      <CardBodyGrid item xs={ 6.5 } container>

        <span className={ "type" }>
          {
            isTest || isSurvey ?
              <Icon
                color={ theme.customColors.textPrimary }
                icon={ isTest ? "test" : "survey" }
                size={ 24 }/> : null
          }
          { isTest ? t("test") : isSurvey ? t("survey") :  typeObjectLearning }
        </span>
        <TitleTypography variant="h3">
          <TruncatedText text={ title } />
        </TitleTypography>

        <DescriptionTypography>
          <TruncatedText text={ shortDescription } maxLength={ 60 } />
        </DescriptionTypography>
        <CardCtaModule
          badge={ badge }
          certificate={ certificate }
          className={ "card-cta" }
          courseId={ courseId }
          disabled={ disabled || isTestCompleted }
          enrollType={ enrollType }
          ecm_specialization={ false }
          ecmRegistration={ false }
          isSurvey={ isSurvey }
          isTest={ isTest }
          id={ id }
          isStandAlone={ isStandAlone }
          isCard={ true }
          learningObjectType={ learningObjectType }
          learningObjectTypology={ learningObjectTypology }
          madeAttempts={ madeAttempts ?? undefined }
          percentageOfCompletion={ percentageOfCompletion }
          rootId={ rootId }
          status={ status }
          canAccessNow={ canAccessNow }
          isLinkRelative={ isLinkRelative }
          link={ link }
          attributesIds={ attributes }
          isHovered={ isHovered }
          isFavourite={ props.isFavourite }
        />
      </CardBodyGrid>
      <CardSignature
        xs={ 2 }
        direction="column"
        gap={ 1 }
        justifyContent={ "flex-end" }
        sx={ {
          minWidth:"185px"
        } }
        color={ theme.customColors.textPrimary }
        isSurvey={ isSurvey }
        isTest={ isTest }
        minimumScore={ minimumScore ?? undefined }
        temptative={ isTest && maxAttempts ? maxAttempts - (madeAttempts ?? 0) : undefined }
        duration={ duration }
        learningActivityNumber={ learningActivityNumber }
        learningObjectTypology={ learningObjectTypology }
        resources={ toolNumber }
      />
    </CardGrid>
  );
}
